export const UNREFINED_KEY = 'unrefined';

export function isUnrefined(refinementKey) {
    return refinementKey === UNREFINED_KEY || !refinementKey;
}